module.exports = __webpack_public_path__ + "img/41596.0f59cb07.jpg";